import { template } from 'lodash';
import { stringify } from 'query-string';
import axios from './client';

const WIDGET_PRICE = template('/widgets/<%= pageId %>/price');

export default function getPdfInvoice(pageId, queryParams) {
  const data = stringify(queryParams, { arrayFormat: 'bracket' });
  return axios.post(WIDGET_PRICE({ pageId }), data, { responseType: 'blob' });
}
